import { Dayjs } from 'dayjs';
import { nanoid } from 'nanoid';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { publicExportsApi } from 'src/Services/API';
import { EventDetailsDtoOriginEnum, EventDto } from 'src/Services/API/generated';

const useFetchExportedEvents = ({
  token,
  startDate,
  endDate,
}: {
  token: string;
  startDate: Dayjs;
  endDate: Dayjs;
}) => {
  const { t } = useTranslation();
  const queryKey = [
    'fetch-exported-events',
    token,
    startDate?.toISOString(),
    endDate?.toISOString(),
  ];

  return useQuery({
    queryKey: queryKey,
    queryFn: async () => {
      const events = (
        (
          await publicExportsApi.publicExportsControllerFindOne(
            token,
            startDate.toISOString(),
            endDate.toISOString()
          )
        ).data as unknown as { entities: EventDto[] }
      ).entities;

      return events
        .map(event => ({ ...event, localId: nanoid() }))
        .map(event => ({
          ...event,
          name:
            event.origin === EventDetailsDtoOriginEnum.PracticalInformation
              ? t(`practicalInformation.subtypes.${event.description}`)
              : event.name,
          description:
            event.origin === EventDetailsDtoOriginEnum.PracticalInformation
              ? t(`practicalInformation.placeholders.${event.name}`)
              : event.description,
        }));
    },
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export default useFetchExportedEvents;
